import SpecialFeatures from './SpecialFeatures'

export default SpecialFeatures
